import { createPortal } from "react-dom";
import ConfirmationPopup from "../../../Components/ConfirmationPopup/ConfirmationPopup";
import { useContext, useState } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";

const PrintReceipt = () => {
  const { userData, route, displayAuthenticationError, setPrintReceiptHTML } =
    useContext(AppContext);
  const [showPrintReceiptPopup, setShowPrintReceiptPopup] = useState(false);
  const [cardDigits, setCardDigits] = useState("");

  const fetchPrintReceipt = async () => {
    if (isNaN(Number(cardDigits))) {
      return window.alert("Invalid Last 4 Entry");
    } else if (cardDigits.length !== 4) {
      return window.alert("Please enter a valid 4 digit number");
    }

    return await fetch(`${route}/invoicetopdf.webapi`, {
      method: "POST",
      headers: {
        Token: userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        Last4: cardDigits,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error();
        }
      })
      .then((response) => {
        setPrintReceiptHTML(response);
        return true;
      })
      .catch((error) => {
        console.log(error);
        window.alert("Error: Unable to print receipt");
        return false;
      });
  };

  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Print Receipt</h3>
      <p className="accountSettingsToggleDescription">
        Need a copy of your account receipt? You can download a copy or print it
        here.
      </p>
      <button
        className="accountSettingsButton"
        onClick={() => setShowPrintReceiptPopup(true)}
      >
        Print Receipt
      </button>
      {showPrintReceiptPopup &&
        createPortal(
          <ConfirmationPopup
            title={`Print Your Receipt`}
            description={`If you need the last four digits of your card added to your receipt, please enter them here.`}
            confirmFunction={fetchPrintReceipt}
            key={"ConfirmationPopup"}
            closePopup={() => setShowPrintReceiptPopup(false)}
          >
            <div className="printReceiptInputContainer">
              <label
                htmlFor="printReceiptInput"
                className="printReceiptInputLabel standardLabel"
              >
                Last Four Digits of Card
              </label>
              <input
                className="standardInput"
                id="printReceiptInput"
                type="text"
                placeholder="Last 4"
                maxLength={4}
                onChange={(e) => setCardDigits(e.target.value)}
                value={cardDigits}
              />
            </div>
          </ConfirmationPopup>,
          document.body
        )}
    </div>
  );
};

export default PrintReceipt;
